import type { ReactNode } from 'react'

import { Text } from '@runtime/components/ui/Text'

import styles from '@runtime/features/profile/auth/fields/FieldGroup.module.scss'

type FieldGroupProps = {
  label: string
  children: ReactNode
}

export default function FieldGroup({ label, children }: FieldGroupProps) {
  return (
    <div className={styles.fieldStack}>
      <Text variant="legend" className={styles.legend}>
        {label}
      </Text>
      {children}
    </div>
  )
}
